import api from './api';

export function getOne(serviceId) {
    return api.get(`/accessibility-statement/${serviceId}`);
}